import module from 'recursoshumanos/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

const diacriticosRegex = /[\u0300-\u036f]/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').toUpperCase().trim()

export class RecursoshumanosDictamenPuestosComponent {
  empresaId
  promise
  periodo = null
  q = null
  operadoras = []
  data = []

  constructor (RecursoshumanosOperadorasService, RecursoshumanosDictamenPuestos, $location) {
    this.RecursoshumanosOperadorasService = RecursoshumanosOperadorasService
    this.RecursoshumanosDictamenPuestos = RecursoshumanosDictamenPuestos
    this.$location = $location
  }

  $onInit () {
    this.promise = this.RecursoshumanosOperadorasService.get()
      .then(({data}) => (this.operadoras = orderBy(data, ['nombre'])))

    if (this.periodo && this.empresaId) {
      this.buscar()
    }
  }

  buscar () {
    if (!this.empresaId || !+this.periodo) return

    this.$location.search({
      id_empresa: this.empresaId,
      periodo: this.periodo,
    })

    this.resultados = []
    this.data = []
    this.buscando = true
    return this.RecursoshumanosDictamenPuestos.get(this.empresaId, this.periodo)
      .then(({data}) => {
        this.data = data
        this.data.forEach((item) => (item.busqueda = normalizar(item.puesto)))
        this.resultados = [...this.data]
      })
      .finally(() => (this.buscando = false))
  }

  filtrar () {
    let filtro = normalizar(this.q)
    this.resultados = this.data.filter(item => normalizar(item.busqueda).indexOf(filtro) >= 0)
  }

  descargar () {
    if (this.descargando) return

    this.descargando = true

    this.RecursoshumanosDictamenPuestos.get(this.empresaId, this.periodo, true)
      .then((response) => (response.data.save()))
      .finally(() => (this.descargando = false))
  }
}

module.component('recursoshumanosDictamenPuestos', {
  controller: RecursoshumanosDictamenPuestosComponent,
  template,
  bindings: {
    empresaId: '<',
    periodo: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/dictamen/puestos/component.js